import { Box, Button, Typography } from '@mui/material'

export default function ErrorFallback({ error, resetErrorBoundary }) {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
            }}
        >
            <Typography variant="h5" sx={{ color: 'error.main' }}>
                Something went wrong:
            </Typography>
            <Typography variant="body1" sx={{ color: 'text.primary', p: 3 }}>
                {error.message}
            </Typography>
            <Button variant="contained" onClick={resetErrorBoundary}>
                Try again
            </Button>
        </Box>
    )
}
